import { SVGProps } from 'react';

export default function ScrapIcon({
  width = 12,
  height = 15,
  fill = 'white',
  stroke,
  strokeWidth,
  ...props
}: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      fill={fill}
      viewBox='0 0 12 16'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <path
        d='M0.777279 2.16704V2.16667C0.777279 1.57745 1.25422 1.1 1.83561 1.1H10.1689C10.7542 1.1 11.2356 1.58137 11.2356 2.16667V14.5901L6.23863 12.4485L6.00228 12.3472L5.76593 12.4485L0.769514 14.5898L0.777279 2.16704Z'
        fill={fill}
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
    </svg>
  );
}
